import React from 'react'
import style from "./marketing.module.css";
import Header from '../components/header/Header';
import Navbar from '../components/navbar/Navbar';
import Footer from '../components/footer/Footer';

const Marketing = () => {
  return (
    <div id='Marketing_Opertunity'>
        <Header/>
        <Navbar/>
        <h1>Marketing Oppurtinity</h1>
        <Footer/>
    </div>
  )
}

export default Marketing
